import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
}

interface IStyleProps {
  lineHeight?: number;
  clampTo?: number;
  fontSize?: number;
  noBlock?: boolean;
}

const styles = ({
  lineHeight,
  clampTo = 0,
  fontSize = 16,
  noBlock = false,
}: IStyleProps): IStyles => ({
  wrapper: {
    fontDefault: fontSize,
    lineHeight: lineHeight ? `${lineHeight}px` : '24px',
    color: colors.space,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    ...(!noBlock && { display: 'block' }),

    ...(clampTo > 0 && {
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': clampTo,
    }),

    ':hover': {
      color: colors.space,
    },
  },
});

export default styles;
